import { Box, Fab, useTheme } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

import { HotelAvailabilityList } from '@frontend/features/hotel/components/Availability';
import { useHotelSearch } from '@frontend/features/hotel/components/Availability/Search/HotelSearchContext';

export const HotelsAvailability = () => {
  const { toggleShowAvailabilityScope} = useHotelSearch();
  const theme = useTheme();
  return (
  <Box display="flex" flexDirection="column">
      <HotelAvailabilityList />
      <Fab color="primary" sx={{ position: 'fixed', bottom: theme.spacing(2), right: theme.spacing(2) }} onClick={toggleShowAvailabilityScope}>
        <InfoOutlined />
      </Fab>
  </Box>
)};
